export default __webpack_public_path__ + "static/media/destroy-white.f061593f.md";